import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { IamService } from '../../service';

export type PasswordPolicyConfigurationConfig = typeof PasswordPolicyConfigurationConfig._.Config;

export const PasswordPolicyConfigurationConfig = IntegrationConfig.make({
  service: IamService,
  name: Integration_Handler_Names_Enum.PasswordPolicyConfiguration,
  configSchema: z.object({}),
});
